import { useParams } from "react-router-dom";

import { useLocalization } from "@i18n";
import { useAccessibleStructuresQuery } from "@shared/api/server/gs3Server";

import GeneralStructureComingSoonPage from "./GeneralStructureComingSoonPage";
import GeneralStructureDashboardPage from "./GeneralStructureDashboardPage";

const GeneralStructurePage = () => {
  const { translate } = useLocalization();
  const { structureId } = useParams<{ structureId: string }>();
  const { data: structures, isLoading } = useAccessibleStructuresQuery("General");

  if (isLoading || !structureId) {
    return (
      <section className="p-6" aria-busy="true">
        <p className="text-sm text-muted-foreground">
          {translate("common.loading")}
        </p>
      </section>
    );
  }

  const structure = structures?.find((item) => item.structureId === structureId);
  const structureType = structure?.structureType;

  if (structureType === "dam") {
    return <GeneralStructureDashboardPage />;
  }

  if (structureType === "stockpile" || structureType === "openPit") {
    return <GeneralStructureComingSoonPage structureType={structureType} />;
  }

  return <GeneralStructureComingSoonPage />;
};

export default GeneralStructurePage;
